/**
 * Serialize error for Redux store (e.g. in rejected action payload).
 * Avoids non-serializable values and keeps a stable shape for logging/debugging.
 */
export function serializeError(error) {
  if (error == null) return null;
  if (typeof error === "object" && "message" in error) {
    return {
      name: error.name || "Error",
      message: error.message || String(error),
      code: error.code,
      response: error.response
        ? {
            status: error.response.status,
            data: error.response.data,
          }
        : undefined,
    };
  }
  return { message: String(error) };
}
